<template>
  <div v-if="broker != null" class="mx-auto w-full lg:max-w-xl my-12">
    <div class="bg-white rounded-lg shadow p-6">
      <div class="text-center">
        <img src="https://img.icons8.com/clouds/100/000000/macbook-settings.png" class="inline" />

        <div class="text-xl font-thin">
          Personalize My {{ getAppName }}
        </div>
      </div>

      <div class="mt-8 px-4">
        <router-view />
      </div>
    </div>

    <div class="text-center mt-4">
      <router-link 
        :to="{
          name  : 'broker-onboard-home',
          params: {
            brokerId   : $route.params.brokerId
          }
        }"
        tag="a" 
        class="text-gray-500 hover:text-gray-200 text-xs border-b border-gray-600 pb-1">Back to {{ getAppName }} Academy</router-link>
    </div>
  </div>
</template>

<script>
  import { EventBus }   from '@/shared/event-bus'
  import PageHeader     from '@/shared/components/headers/PageHeader'
  import SubmitButton2   from '@/shared/components/form/SubmitButton2'
  
  export default {

    components: {
      PageHeader,
      SubmitButton2
    },

    data () {
      return {
        loading: false,
        broker : null,
      }
    },

    mounted() {
      document.body.className = 'onboard-bg'
    },

    beforeDestroy() {
      document.body.className = ''
    },

    created() {
      this.getBroker({
        brokerId: this.$route.params.brokerId
      }, (broker) => {
        this.broker = broker
      })
    },
  }
</script>